import React from 'react'
import Image from "../img/photo-grid.png";

const Main = () => {
  return (
      <div>
          <section className='header'>
          <img src={Image} alt="head-img" />
          <h1 className='head-title'>Providing the best services</h1>
              <p className='head-text'>Join the community where can get to spend time for your vacation</p>
          </section>
              
    </div>
  )
}

export default Main
